
export const logger = (...args: unknown[]): void => {
	console.log('[FPGPT]', ...args);
};

export const loggerError = (...args: unknown[]): void => {
	console.error('[FPGPT]', ...args);
};

const getUrlParam = (paramKey: string, pageUrl: URL): string | null => {
	const url = new URL(pageUrl);
	const queryParams = new URLSearchParams(url.search);
	return queryParams.get(paramKey);
};

/* Function receives text and returns the text with all urls linkified
* 	Example input: 'Hello, please visit https://www.google.com.'
*  output: 'Hello, please visit <a href="https://www.google.com" target="_blank" class="color-primary">https://www.google.com</a>.'
*/
export const linkifyUrlInText = (text: string): string => {
	if (!text) {
		return text;
	}
	const urlRegex = /(\bhttps?:\/\/[^\s]+)/g;
	return text.replace(urlRegex, (match: string) => {
		// remove trailing punctuation from url if it exists
		let punctuation = '';
		let url = match;
		if (/[.,;-]$/.test(match)) {
			url = match.slice(0, -1);
			punctuation = match[match.length - 1];
		}
		return `<a href="${url}" target="_blank" class="text-primary">${url}</a>${punctuation}`;
	});
};

export const convertNameIntoFirstAndLast = (name: string): Record<string, string> => {
	const payload = {
		first_name: '',
		last_name: '',
	};

	if (name) {
		const namePieces = name.trim().split(' ');
		payload.last_name = namePieces.length > 1 ? namePieces.pop() as string : '';
		payload.first_name = namePieces.join(' ').trim();
	}
	return payload;
};

export const shouldUseMockData = (trackParams: Record<string, any>): boolean => {
	return getUrlParam('mock-data', trackParams?.url) === '1';
};

export const hexToRgb = (hex: string): string => {
	// Remove the '#' character if present
	hex = hex.replace(/^#/, '');

	// Parse the hex color
	let r, g, b;
	if (hex.length === 3) {
		r = parseInt(hex[0] + hex[0], 16);
		g = parseInt(hex[1] + hex[1], 16);
		b = parseInt(hex[2] + hex[2], 16);
	} else if (hex.length === 6) {
		r = parseInt(hex.slice(0, 2), 16);
		g = parseInt(hex.slice(2, 4), 16);
		b = parseInt(hex.slice(4, 6), 16);
	} else {
		return '';
	}

	return `${r}, ${g}, ${b}`;
};

export const extractDomainFromUrl = (url: string): string => {
	if (!url) {
		return '';
	}
	try {
		const TOP_LEVEL_DOMAIN_MAX_LENGTH = 3;
		const VALID_TOP_LEVEL_DOMAINS = ['auto', 'cars'];
		const urlParts = new URL(url)?.hostname?.split('.');
		// Iterate through the array in reverse to identify the first part of the URL that is NOT a top-level domain
		let domainIndex = -1;
		for (let i = urlParts.length - 1; i >= 0; i--) {
			if (urlParts[i].length > TOP_LEVEL_DOMAIN_MAX_LENGTH && !VALID_TOP_LEVEL_DOMAINS.includes(urlParts[i])) {
				domainIndex = i;
				break;
			}
		}
		return urlParts.slice(domainIndex).join('.');
	} catch {
		return '';
	}
};

export const isLocalhost = (): boolean => {
	return window.location.hostname === 'localhost';
};

export const setCookie = (name: string, value: string, days = 365): void => {
	if (!name || !value) {
		return;
	}
	const date = new Date();
	date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	const domain = isLocalhost() ? '' : ' domain=.fullpath.com;';
	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; SameSite=None; Secure;` + domain;
};
